import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup.js';
import Pagination from '../layouts/pagination.jsx';
// import DeleteComponent from '../../action/delete.jsx';
import UpdateStatusComponent from '../../action/updatestatus.jsx';
import AddProjectMeter from './sections/add';
import EditProjectMeter from './sections/edit';
import ViewProjectMeter from './sections/view.jsx';
import ExcelExport from './sections/export.jsx';


const ProjectMeter = () => {
    const [projectMeters, setProjectMeters] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [meterId, setMeterId] = useState(null);
    const [filterChannel, setFilterChannel] = useState('');
    const [filterClient, setFilterClient] = useState('');
    const [filterProject, setFilterProject] = useState('');
    const [exportProjectMeters, setExportProjectMeters] = useState([]);

    const fetchExportEmployees = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/project_meter`)
            .then(response => {
                setExportProjectMeters(response.data.data);
            })
            .catch(error => {
                console.error("Error fetching employees!", error);
                setExportProjectMeters([]);
            });
    };

    const fetchProjectMeters = async (currentPage) => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/project_meter?page=${currentPage + 1}`)
            .then(response => {
                setProjectMeters(response.data.data);
                setPageCount(Math.ceil(response.data.meta.pagination.total / response.data.meta.pagination.per_page));
            })
            .catch(error => {
                console.error("Error fetching project meters!", error);
                setProjectMeters([]);
            });
    };

    useEffect(() => {
        fetchProjectMeters(currentPage);
        fetchExportEmployees();
    }, [currentPage]);
    
    const handlePageClick = (event) => {
        setCurrentPage(event.selected);
    };

    // Search input handler
    const filteredItems = projectMeters.filter((item) => {
        const matchesChannel = item.channel.toLowerCase().includes(filterChannel.toLowerCase());
        const matchesClient = item.client.toLowerCase().includes(filterClient.toLowerCase());
        const matchesProject = item.project.toLowerCase().includes(filterProject.toLowerCase());
        return matchesChannel && matchesClient && matchesProject;
    });

    return (
        <>    
            <div className="content container-fluid">
                <div className="page-header">
                    <div className="row align-items-center">
                        <div className="col">
                            <h3 className="page-title">Project Meter</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Project Meter</li>
                            </ul>
                        </div>
                        <div className="col-auto float-end ms-auto">
                            <Link to="#" className="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_project_meter"><i
                                    className="fa-solid fa-plus"></i> Add Project Meter</Link>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Channel..." aria-label="Search Input"
                            value={filterChannel} onChange={(event)=>{
                                setFilterChannel(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Client..." aria-label="Search Input"
                            value={filterClient} onChange={(event)=>{
                                setFilterClient(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3">
                        <input className="form-control" type="text"
                            placeholder="Search Project..." aria-label="Search Input"
                            value={filterProject} onChange={(event)=>{
                                setFilterProject(event.target.value)
                            }} />
                    </div>
                    <div className="col-md-3 mb-3" align="right">
                        <ExcelExport data={exportProjectMeters} fileName="ActiveProjectMeter" />
                    </div>
                </div>

                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="table-responsive">
                                    <table className="table table-striped custom-table">
                                        <thead>
                                            <tr>
                                                <th>Channel</th>
                                                <th>Client</th>
                                                <th>Project</th>
                                                <th>Meter</th>
                                                <th>Meter Type</th>
                                                <th>Meter Price</th>
                                                <th>Status &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                </th>
                                                <th className="text-end">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                filteredItems.length > 0 ? (
                                                    filteredItems.map((item) => (
                                                        <tr key={item.id}>
                                                            <td>{item.channel}</td>
                                                            <td>{item.client}</td>
                                                            <td>{item.project}</td>
                                                            <td>{item.meter}</td>
                                                            <td>{item.meter_type === '1' ? 'Hourly' : 'Fixed' }</td>
                                                            <td>{item.price}</td>
                                                            <td>
                                                                <UpdateStatusComponent 
                                                                    url = "project_meter/status"
                                                                    id = {item.id}
                                                                    fetchData={fetchProjectMeters} 
                                                                    status={item.status}
                                                                    />                                                                
                                                            </td>
                                                            <td className="text-end">
                                                                <div className="dropdown dropdown-action">
                                                                    <Link to="#" className="action-icon dropdown-toggle"
                                                                        data-bs-toggle="dropdown" aria-expanded="false"
                                                                            onClick={() => setMeterId(`${item.id}`)}>
                                                                            <i className="material-icons">more_vert</i></Link>
                                                                    <div className="dropdown-menu dropdown-menu-right">
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#view_project_meter_${item.id}`}>
                                                                                <i className="fa-solid fa-eye m-r-5"></i> View</Link>
                                                                        <Link className="dropdown-item" to="#" data-bs-toggle="modal"
                                                                            data-bs-target={`#edit_project_meter_${item.id}`}>
                                                                                <i className="fa-solid fa-pencil m-r-5"></i> Edit</Link>
                                                                            {/* <DeleteComponent 
                                                                                url = "project_meter"
                                                                                id = {item.id}
                                                                                fetchData={fetchProjectMeters} /> */}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="8">No records found</td>
                                                    </tr>
                                                )                                          
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Pagination pageCount={pageCount} handlePageClick={handlePageClick}/>
            </div>

            <AddProjectMeter list={fetchProjectMeters}/>
            <EditProjectMeter list={fetchProjectMeters} meterId={meterId} />
            <ViewProjectMeter meterId={meterId} />
        </>
    );
}

export default ProjectMeter